import { Subtitle, Title } from '@panwds/react-ui'

const Header = ({ title = '', subTitle = '', linkText = '', linkUrl = '' }) => {
  return (
    <div className='tw-flex tw-flex-1 tw-flex-col'>
      <div className='tw-p-6 tw-border-solid cm-border-[#DADBDB] dark:cm-border-[#242424] tw-bg-white dark:tw-bg-gray-1050'>
        <Title level={3}>
          {title}
        </Title>
        <Subtitle>{subTitle} {linkText && linkUrl ? <a className='tw-text-link tw-text-base tw-cursor-pointer' rel="noreferrer" target="_blank" href={linkUrl}>
          {linkText}
        </a> : ''} </Subtitle>
      </div>
    </div>
  )
}
export default Header
